import { Injectable } from '@angular/core';
import { createState, Store } from '@ngneat/elf';
import { withActiveId, withEntities } from '@ngneat/elf-entities';
import {
  createRequestsStatusOperator,
  withRequestsStatus,
} from '@ngneat/elf-requests';
import { Requirement } from '@prisma/client';
import { CRUDRepository } from '../../shared/crud/repository';
import { loadList } from './requirement.actions';

type StatusPaths = 'list' | 'item';

const { state, config } = createState(
  withEntities<Requirement>(),
  withActiveId(),
  withRequestsStatus<StatusPaths>()
);

export const store = new Store({ name: 'requirements', config, state });
export const trackRequestsStatus = createRequestsStatusOperator(store);

@Injectable({ providedIn: 'root' })
export class RequirementRepository extends CRUDRepository<
  Requirement,
  typeof store
> {
  constructor() {
    super(store, { loadListAction: loadList });
  }

  public override searchEntity(entity: Requirement, searchText: string) {
    searchText = searchText.toLowerCase();
    if (entity.name) {
      if (entity.name?.toLocaleLowerCase().indexOf(searchText) !== -1)
        return true;
    }
    return false;
  }

}
